import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "開案年份",
    isNumber: true,
    isSum: true,
    isDate: true,
  },
];

export const AnnualApplicationStatistic = {
  label: "年度申請結果統計",
  key: "AnnualApplicationStatistic",
  path: "ServiceApplication/AnnualApplicationStatistic",
  api: "TCS_V_ServiceApplication_6",
  render: (options) => (
    <Diagram.ServiceApplication.AnnualApplicationStatistic {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  dateRangeColumns: [{ label: "開案日期", key: "開案日期" }],
  groupColumns: [
    {
      key: "申請結果",
      field: "申請結果",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
